/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCalendarBlank: {
  name: 'calendar-blank';
  data: string;
} = {
  name: 'calendar-blank',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 2a1 1 0 0 1 1 1v1h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V3a1 1 0 0 1 2 0v1h6V3a1 1 0 0 1 1-1ZM7 6v1a1 1 0 0 0 2 0V6h6v1a1 1 0 1 0 2 0V6h2v5H5V6h2Zm-2 7h14v7H5v-7Zm3 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3-1a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
